import { useState } from "react";
import axios from 'axios';
import backendUrl from "../../config";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import { motion, AnimatePresence } from 'framer-motion';
import { useStatusReset } from "../../hooks/useStatusReset";

export default function Subscribe() {
    const [email, setEmail] = useState(""); // State to store the email input
    const [status, setStatus] = useState(""); // State to store success/error messages
    const [statusType, setStatusType] = useState("");
    const [loading, setLoading] = useState(false);

    const BACKENDURL = backendUrl;
    // const BACKENDURL = "http://localhost:5000"

    // Reset status after 2s
    useStatusReset(status, setStatus, 2000)

    const handleSubscribe = async () => {
        if (!email) {
            setStatus('Please enter a valid email.');
            setStatusType("error");
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(`${BACKENDURL}/subscribe/email-signup`, {email});
            if (response.status === 200) {
                setStatus("Thank you for subscribing!");
                setStatusType("success");
                setEmail("");
            } else {
                setStatus(response.data.error || "Failed to subscribe. Please try again");
                setStatusType("error");
            }
        } catch (error) {
            if (axios.isAxiosError(error)){
                // console.error("Error subscribing: ", error); // removed for production security reason
                setStatus(error.response?.data?.error || "An error occurred. Please try again later.");
                setStatusType("error");
            }else{
                setStatus("An unexpected error occurred. Please try again later.");
            }
            
        } finally {
            setLoading(false); // Stop loading when subscription is complete
        }
    }

    return (
        <>
        <Header />
        <div className="relative overflow-hidden flex justify-center items-center w-full h-screen">
            {/* Motion lines */}
            {/* Blue line animation from left to right (only once) */}
            <motion.div
                initial={{ scaleX: 0 }}
                animate={{ scaleX: 1 }}
                transition={{ duration: 1.0, ease: 'easeOut' }}
                className="absolute top-[10%] left-0 origin-left h-[6rem] w-full bg-[#249CFF] z-0"
            />
            <motion.div
                initial={{ scaleX: 0 }}
                animate={{ scaleX: 1 }}
                transition={{ duration: 1.4, ease: 'easeOut' }}
                className="absolute top-[12%] left-0 origin-left h-[0.5rem] w-full bg-white z-0"
            />
            <motion.div
                initial={{ scaleX: 0 }}
                animate={{ scaleX: 1 }}
                transition={{ duration: 1.0, ease: 'easeOut' }}
                className="absolute bottom-[15%] right-0 origin-right h-[4rem] w-full bg-black z-0"
            />
            <motion.div
                initial={{ scaleX: 0 }}
                animate={{ scaleX: 1 }}
                transition={{ duration: 1.4, ease: 'easeOut' }}
                className="absolute bottom-[16%] right-0 origin-right h-[0.5rem] w-full bg-white z-0"
            />
            <div className="flex flex-col w-[80%] md:w-1/2 gap-y-[2rem]">
                <div className="text-xl md:text-4xl font-bold">
                    <h1>Stay updated on <span className="text-[#249CFF]">Takamori Robot</span></h1>
                    <h2><span className="text-[#249CFF]">Subscribe</span> to hear moment we launch our kickstarter.</h2>
                </div>
                <div className="shadow-2xl hover:shadow-[#249CFF]">
                    {/* <h3 className="subscribe-input-heading">Email</h3> */}
                    <input 
                        className="w-full h-10 px-3 text-sm text-gray-700 border border-r rounded-r-none border-blue-500 focus:outline-none rounded" 
                        type="text" 
                        placeholder="example@email.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                <div className="group relative flex flex-row justify-center items-center before:ease relative h-12 w-32 overflow-hidden border text-black shadow-2xl transition-all before:absolute before:top-1/2 before:h-0 before:w-64 before:origin-center before:-translate-x-20 before:rotate-45 before:bg-blue-500 before:duration-300 hover:text-white hover:shadow-[#249CFF] hover:before:h-64 hover:before:-translate-y-32">
                    <button
                        id="submit-button"
                        onClick={handleSubscribe}
                        disabled={loading}
                        className="group relative w-full h-full flex items-center justify-center"
                    >
                        {loading ? (
                            <div className="relative group w-5 h-5 border-2 border-[#249CFF] border-t-white rounded-full animate-spin" />
                        ) : (
                            <div className="relative text-[#249CFF] z-10 group-hover:text-white transition duration-200">
                                SUBSCRIBE
                            </div>
                        )}
                    </button>
                </div>
                <AnimatePresence>
                    {status && (
                        <motion.div
                            key="status-message"
                            initial={{ opacity: 0, y: 50 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 50 }}
                            transition={{ duration: 1 }}
                            className={`absolute bottom-[20%] -translate-x-1/2 mt-2 w-[80%] md:w-[50%]
                                flex items-center justify-center gap-3 px-4 py-3 rounded-lg text-sm font-medium shadow-md
                                ${statusType === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}
                        >
                            <div className="flex items-center justify-center w-5 h-5">
                                {statusType === 'success' ? (
                                <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                </svg>
                                ) : (
                                <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                                )}
                            </div>
                        <p>{status}</p>
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>

        </div>
        <Footer />
        </>
    );
}